// extracted by mini-css-extract-plugin
export default {"loginForm":"changePasswordForm_loginForm__-XmvJ"};